import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  presentation as presentationPropType,
  widget as widgetPropType,
} from 'lib/CustomPropTypes';

import loadScript from 'lib/loadScript';

import styles from '../styles.module.scss';

export default class FacebookEmbed extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    presentation: presentationPropType.isRequired,
    widget: widgetPropType.isRequired,
    facebookPostType: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    facebookPostType: 'post',
  };

  componentDidMount() {
    loadScript('https://connect.facebook.net/en_US/sdk.js#xfbml=false&version=v2.10')
      // re-initing here since in SPA mode, the script needs to re-parse
      // embeds on the page when navigating to a new article
      .thenOnFirstLoad(() => window.FB.init({ version: 'v2.10', xfbml: true }))
      .then(() => window.FB.XFBML.parse());
  }

  getPostUrl() {
    const { widget } = this.props;

    return widget.properties['facebookplus-post-url']
      || widget.properties['video-url'];
  }

  wrapped() {
    // FB's library adds an in-line 100% width, so we need to wrap it with our correct width
    const { presentation: { size }, className, facebookPostType } = this.props;
    const classes = classNames({
      'fb-video': facebookPostType === 'video',
    });
    return (
      <div className={classNames(styles.usePresentation, { [className]: className })}>
        <div
          className={classes}
          data-href={this.getPostUrl()}
          data-show-text="true"
          width={size.toLowerCase() === 'small' ? 360 : null}
          ref={(div) => { this.containerDiv = div; }}
        />
      </div>
    );
  }

  render() {
    const { className, facebookPostType } = this.props;
    const classes = classNames({
      [styles.usePresentation]: true,
      [className]: className,
      'fb-post': facebookPostType === 'post',
    });

    if (facebookPostType === 'video') {
      return this.wrapped();
    }

    return (
      <div
        className={classes}
        data-href={this.getPostUrl()}
        data-show-text="true"
        data-width="auto"
        ref={(div) => { this.containerDiv = div; }}
      />
    );
  }
}
